

import { MiRouter } from './router/MiRouter';


function App() {
  return (
    <div className='layout' >
      <MiRouter />
    </div>
  );
}

export default App;
